import { format } from 'date-fns';
import {
  useEffect,
} from 'react';

import { useWidgetState } from './use-widget-state';

/**
 * A custom hook for Aspenware Link(s) with Date tab type
 * @returns {CustomTabState} a map of state and state update functions for
 *  all `Aspenware Link(s) with Date` tabs
 */
export const useAspenwareLinksDate = ({
  commerceEngineUrl,
  dropdownOptions,
}) => {
  const {
    tabValues,
    setTabValues,
    buttonLink,
    setButtonLink,
  } = useWidgetState();
  const components = [
    {
      type: 'datepicker',
      ariaLabel: 'Select start date',
      name: 'start_date',
      placeholder: 'Start Date',
      isDefaultDate: false,
      isCurrentDaySelectable: true,
      maxDaysToBookAhead: 550,
      prettyDate: 'MMM dd yyyy',
      dateFormat: 'MM/dd/yyyy',
    },
    {
      name: 'product_name',
      ariaLabel: 'Select desired product',
      type: 'select',
      placeholder: 'Select a product...',
      choices: dropdownOptions
        .map((option) => ({
          label: option.buttonText,
          value: option.buttonLink,
          productId: option.productId,
        }
        )),
    },
  ];

  useEffect(() => {
    if (tabValues[components[0].name] && tabValues[components[1].name]?.value) {
      const { minDate, selectedDate } = tabValues[components[0].name];
      setButtonLink(`${commerceEngineUrl}${tabValues[components[1].name].value}?${tabValues[components[1].name]?.productId}=${format(selectedDate || minDate, 'yyyy-MM-dd')}`);
    }
  }, [tabValues]);

  return {
    setTabValues,
    buttonLink,
    components,
  };
};
